import { useRef, type TouchEvent as ReactTouchEvent } from 'react';

// Touch-swipe month navigation shared by the public and admin calendars.
// Rejects too-slow drags, too-short swipes, and mostly-vertical motions
// (which usually mean the user is scrolling, not navigating).
export function useMonthSwipe(opts: {
  onPrev?: () => void;
  onNext?: () => void;
}) {
  const touchStart = useRef<{ x: number; y: number; t: number } | null>(null);

  const onTouchStart = (e: ReactTouchEvent) => {
    const t = e.touches[0];
    if (!t) return;
    touchStart.current = { x: t.clientX, y: t.clientY, t: Date.now() };
  };

  const onTouchEnd = (e: ReactTouchEvent) => {
    const start = touchStart.current;
    touchStart.current = null;
    if (!start) return;
    const end = e.changedTouches[0];
    if (!end) return;
    const dx = end.clientX - start.x;
    const dy = end.clientY - start.y;
    const dt = Date.now() - start.t;
    if (dt > 600) return;
    if (Math.abs(dx) < 60) return;
    if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
    if (dx < 0) opts.onNext?.();
    else if (dx > 0) opts.onPrev?.();
  };

  return { onTouchStart, onTouchEnd };
}
